/**
 * @generated SignedSource<<2e96995cd41622171f58df93d4ef5369>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type onboardingState_state$data = ReadonlyArray<{
  readonly key: string;
  readonly value: string | null;
  readonly " $fragmentType": "onboardingState_state";
}>;
export type onboardingState_state$key = ReadonlyArray<{
  readonly " $data"?: onboardingState_state$data;
  readonly " $fragmentSpreads": FragmentRefs<"onboardingState_state">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true,
    "throwOnFieldError": true
  },
  "name": "onboardingState_state",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "value"
    }
  ],
  "type": "OnboardingState"
};

(node as any).hash = "da011c9ee7ee2f3537016ecf931bb29c";

export default node;
